# frozen_string_literal: true

module Engine
  module Game
    module GRollingStock
    end
  end
end
